import { render, staticRenderFns } from "./url.vue?vue&type=template&id=ddeb86ec&scoped=true&"
import script from "./url.vue?vue&type=script&lang=js&"
export * from "./url.vue?vue&type=script&lang=js&"
import style0 from "./url.vue?vue&type=style&index=0&id=ddeb86ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb86ec",
  null
  
)

export default component.exports